/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicRewards.internal

import features.publicRewards.models.PublicRewardsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class PublicRewardsRequest : NetworkRequest() {

    suspend fun getPublicRewards(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<PublicRewardsModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicRewardsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
